export default __webpack_public_path__ + "static/media/error1.0de095cf.jpg";